import React from 'react';
// import Translation from '../translation/translation';

function CrossSellLightBoxHeader({ title }) {
    return (
        <div className="cross-sell-light-box__header cross-sell-light-box-header">
        </div>
    );
}

export { CrossSellLightBoxHeader };
